import { defineMessages } from 'react-intl';

/** The copy of the Monthly add-ons section (design monthly-addons a, b). */
export const monthlyAddOnMessages = defineMessages({
  title: { id: 'app.sml.settings.addOns.title', defaultMessage: 'Monthly add-ons' },
  lead: {
    id: 'app.sml.settings.addOns.lead',
    defaultMessage: 'Add more to your plan, every month. Change or remove them at any time.',
  },
  billedMonthly: { id: 'app.sml.settings.addOns.billedMonthly', defaultMessage: 'Billed with your plan' },
  billedYearly: { id: 'app.sml.settings.addOns.billedYearly', defaultMessage: 'Billed yearly with your plan' },

  postsName: { id: 'app.sml.settings.addOns.posts.name', defaultMessage: 'Extra scheduled posts' },
  postsSub: {
    id: 'app.sml.settings.addOns.posts.sub',
    defaultMessage: 'Posts that MUSIC24 publishes for you, on top of your plan.',
  },
  creditsName: { id: 'app.sml.settings.addOns.credits.name', defaultMessage: 'Extra video credits' },
  creditsSub: {
    id: 'app.sml.settings.addOns.credits.sub',
    defaultMessage: 'For reels, clips and kit videos. Your plan credits go first.',
  },
  creditsPoolSub: {
    id: 'app.sml.settings.addOns.credits.poolSub',
    defaultMessage: 'Added to the team pool, not to each artist.',
  },

  artistsName: { id: 'app.sml.settings.addOns.artists.name', defaultMessage: 'Extra artists' },
  artistsSub: {
    id: 'app.sml.settings.addOns.artists.sub',
    defaultMessage:
      'Each more artist: {price} a month, 20 % off. It gets the full {plan} limits: {posts} posts and {credits} video credits a month.',
  },
  artistsSubYear: {
    id: 'app.sml.settings.addOns.artists.subYear',
    defaultMessage:
      'Each more artist: {price} a year, 20 % off. It gets the full {plan} limits: {posts} posts and {credits} video credits a month.',
  },
  artistsUnit: { id: 'app.sml.settings.addOns.artists.unit', defaultMessage: 'artists' },
  artistsValueText: {
    id: 'app.sml.settings.addOns.artists.valueText',
    defaultMessage: '{count, plural, =0 {No extra artists} one {# extra artist} other {# extra artists}}',
  },
  artistsChip: { id: 'app.sml.settings.addOns.artists.chip', defaultMessage: '{price} an artist' },
  artistsTotal: {
    id: 'app.sml.settings.addOns.artists.total',
    defaultMessage: '{total} artists in all ({base} with {plan})',
  },
  artistsBase: { id: 'app.sml.settings.addOns.artists.base', defaultMessage: '{base} artists with {plan}' },
  artistsFromNext: {
    id: 'app.sml.settings.addOns.artists.fromNext',
    defaultMessage: '{total} artists from {date} (now {now})',
  },
  artistsInUse: {
    id: 'app.sml.settings.addOns.artists.inUse',
    defaultMessage:
      '{artists, plural, one {# artist} other {# artists}} in your workspace use {inUse, plural, one {# extra artist} other {# extra artists}}. Remove an artist first to go lower.',
  },
  artistsManagerCap: {
    id: 'app.sml.settings.addOns.artists.managerCap',
    defaultMessage: 'Up to {max} extra artists on {plan}. For more, move to Ultra.',
  },
  moreArtists: {
    id: 'app.sml.settings.addOns.artists.more',
    defaultMessage: 'Need more artists? Plus, Pro, Max and Ultra add artists at 20 % off the plan price.',
  },
  savedTeam: {
    id: 'app.sml.settings.addOns.savedTeam',
    defaultMessage: 'Saved. You now have {posts} posts, {credits} video credits a month and {artists} artists.',
  },
  memberLeadTeam: {
    id: 'app.sml.settings.addOns.member.leadTeam',
    defaultMessage: 'Extra posts, video credits and artists on top of the plan.',
  },
  memberArtists: {
    id: 'app.sml.settings.addOns.member.artists',
    defaultMessage: '{count, plural, one {+# artist} other {+# artists}}',
  },

  value: { id: 'app.sml.settings.addOns.value', defaultMessage: '{count, plural, =0 {0} other {+#}}' },
  aMonth: { id: 'app.sml.settings.addOns.aMonth', defaultMessage: 'a month' },
  valueText: {
    id: 'app.sml.settings.addOns.valueText',
    defaultMessage: '{count, plural, =0 {None} other {# more a month}}',
  },

  postsTotal: {
    id: 'app.sml.settings.addOns.posts.total',
    defaultMessage: '{total} posts a month in all ({base} with {plan})',
  },
  postsBase: { id: 'app.sml.settings.addOns.posts.base', defaultMessage: '{base} posts a month with {plan}' },
  postsFromNext: {
    id: 'app.sml.settings.addOns.posts.fromNext',
    defaultMessage: '{total} posts a month from {date} (now {now})',
  },
  creditsTotal: {
    id: 'app.sml.settings.addOns.credits.total',
    defaultMessage: '{total} video credits a month in all ({base} with {plan})',
  },
  creditsBase: {
    id: 'app.sml.settings.addOns.credits.base',
    defaultMessage: '{base} video credits a month with {plan}',
  },
  creditsFromNext: {
    id: 'app.sml.settings.addOns.credits.fromNext',
    defaultMessage: '{total} video credits a month from {date} (now {now})',
  },
  creditsPoolTotal: {
    id: 'app.sml.settings.addOns.credits.poolTotal',
    defaultMessage: 'Team pool: {total} credits a month ({base} for your artists + {extra})',
  },
  unlimited: { id: 'app.sml.settings.addOns.unlimited', defaultMessage: 'No limit with {plan}' },

  priceMonth: { id: 'app.sml.settings.addOns.priceMonth', defaultMessage: '{price} a month' },
  priceYear: { id: 'app.sml.settings.addOns.priceYear', defaultMessage: '{price} a year' },
  tierRange: { id: 'app.sml.settings.addOns.tierRange', defaultMessage: '{from}–{to} · {price}' },
  tierOpen: { id: 'app.sml.settings.addOns.tierOpen', defaultMessage: '{from}+ · {price}' },

  postsFirst: { id: 'app.sml.settings.addOns.posts.first', defaultMessage: 'First {count} posts: {price} each' },
  postsNext: { id: 'app.sml.settings.addOns.posts.next', defaultMessage: 'Next {count} posts: {price} each' },
  postsMore: { id: 'app.sml.settings.addOns.posts.more', defaultMessage: 'More posts: {price} each' },
  creditsFirst: {
    id: 'app.sml.settings.addOns.credits.first',
    defaultMessage: 'First {count} credits: {price} each',
  },
  creditsNext: { id: 'app.sml.settings.addOns.credits.next', defaultMessage: 'Next {count} credits: {price} each' },
  creditsMore: { id: 'app.sml.settings.addOns.credits.more', defaultMessage: 'More credits: {price} each' },

  sum: {
    id: 'app.sml.settings.addOns.sum',
    defaultMessage: '<b>{plan}</b> {planPrice} + <b>add-ons</b> {addOnsPrice}',
  },
  totalYearSmall: { id: 'app.sml.settings.addOns.totalYear', defaultMessage: 'a year · {monthly} a month' },
  reset: { id: 'app.sml.settings.addOns.reset', defaultMessage: 'Reset' },
  save: { id: 'app.sml.settings.addOns.save', defaultMessage: 'Save add-ons' },
  saving: { id: 'app.sml.settings.addOns.saving', defaultMessage: 'Saving' },
  riseFoot: {
    id: 'app.sml.settings.addOns.riseFoot',
    defaultMessage: 'More starts now: your next invoice adds the rest of this period. Taxes depend on your country.',
  },
  lowerNote: {
    id: 'app.sml.settings.addOns.lowerNote',
    defaultMessage:
      "Lower values start with your next billing period, on {date}. You keep this period's limits until then. There is no refund for this period.",
  },
  lowerNoteNoDate: {
    id: 'app.sml.settings.addOns.lowerNoteNoDate',
    defaultMessage:
      "Lower values start with your next billing period. You keep this period's limits until then. There is no refund for this period.",
  },
  saved: {
    id: 'app.sml.settings.addOns.saved',
    defaultMessage: 'Saved. You now have {posts} posts and {credits} video credits a month.',
  },
  saveFailed: {
    id: 'app.sml.settings.addOns.saveFailed',
    defaultMessage: 'We could not change your add-ons. Try again.',
  },

  memberLead: {
    id: 'app.sml.settings.addOns.member.lead',
    defaultMessage: 'Extra posts and video credits on top of the plan.',
  },
  memberNone: { id: 'app.sml.settings.addOns.member.none', defaultMessage: 'No add-ons on this plan.' },
  memberValue: { id: 'app.sml.settings.addOns.member.value', defaultMessage: '+{count} a month' },
  ownerOnly: {
    id: 'app.sml.settings.addOns.member.ownerOnly',
    defaultMessage: 'Only the workspace owner can change add-ons.',
  },

  storeLead: {
    id: 'app.sml.settings.addOns.store.lead',
    defaultMessage: 'Add more posts and video credits to your plan, every month.',
  },
  storeAppStore: {
    id: 'app.sml.settings.addOns.store.appStore',
    defaultMessage:
      'Your plan is billed by the App Store. Add-ons are sold on the web only. To buy them, cancel the plan in the App Store, then choose it again here when it ends.',
  },
  storeGooglePlay: {
    id: 'app.sml.settings.addOns.store.googlePlay',
    defaultMessage:
      'Your plan is billed by Google Play. Add-ons are sold on the web only. To buy them, cancel the plan in Google Play, then choose it again here when it ends.',
  },
  storeLink: { id: 'app.sml.settings.addOns.store.link', defaultMessage: 'How to move to web billing' },

  needsPlanLead: {
    id: 'app.sml.settings.addOns.needsPlan.lead',
    defaultMessage: 'Add-ons are for paid plans. Choose a plan, then add more posts and video credits each month.',
  },
  // QA 2026-10-28 skp-17: Free and the trial see the price of the add-ons before they choose a plan.
  needsPlanPrices: {
    id: 'app.sml.settings.addOns.needsPlan.prices',
    defaultMessage:
      'Extra posts cost {post} each and extra video credits {credit} each, every month. Bigger amounts cost less for each one.',
  },
  seePlans: { id: 'app.sml.settings.addOns.needsPlan.seePlans', defaultMessage: 'See plans' },
  noWebLead: {
    id: 'app.sml.settings.addOns.noWeb.lead',
    defaultMessage:
      'This plan has no web subscription, so it cannot take add-ons here. Contact support to add add-ons to this plan.',
  },
  contactSupport: { id: 'app.sml.settings.addOns.noWeb.contactSupport', defaultMessage: 'Contact support' },
});
